export default "__VITE_ASSET__dbb7ec48__"